import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./LatestCostumerReview.module.scss"
const LatestCostumerReview = ({ title, review, video }) => {
  return (
    <Section
      container={"large"}
      className={`${classNames.container} + pbl-8`}
    >
      <h2>{title}</h2>
      <div className={classNames.reviewContainer}>
        <>
          <div className={classNames.video}>
            <video
              src={video?.url}
              alt={video?.alternativeText}
              controls
            ></video>
          </div>

          <div className={classNames.review}>
            <h3>"{review.description}"</h3>
            <p>
              <strong>{review.nom}</strong>
            </p>
            <p>{review.emploi}</p>
          </div>
        </>
      </div>
    </Section>
  )
}
export const name = "LatestCostumerReview"

export const init = (componentData) => {
  return (
    <LatestCostumerReview
      key={componentData.id}
      review={componentData.avis_client?.data?.attributes}
      video={
        componentData.avis_client?.data?.attributes.video?.data?.attributes
      }
      title={componentData.label}
    />
  )
}

export default LatestCostumerReview
